// import Item from 'antd/es/list/Item';
// import React, { useEffect, useState } from 'react';
import { Form } from "react-bootstrap";

const VerticalTable2 = ({ other, setOther }) => {
  const handleToggle = (key) => {
    setOther((prev) => ({
      ...prev,
      [key]: prev[key] === "YES" ? "NO" : "YES",
    }));
  };

  return (
    <table>
      <th>
        <td>Asset features identified</td>
      </th>
      <tbody>
        {Object.keys(other).map((key) => {
          return (
            <tr key={key}>
              <td style={{ paddingRight: "10px" }}>{key}</td>&nbsp;
              <td>
                <div className="d-flex justify-content-center align-items-center">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label={other[key] === "YES" ? "YES" : "NO"}
                    checked={other[key] === "YES" ? true : false}
                    onChange={() => handleToggle(key)}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default VerticalTable2;
